// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"_1SgQP8ftN8buvRYYKuu-Ii","search":"_3BHGUHJPFCV4-wpNVYa30G","resultsPaper":"_1GJTszG_jMEcsL4PktMgMF","resultsHolder":"_1ATYHqfhXSWGm9tys4eecw"};